/**
 * @generated SignedSource<<aaa30505cea49cb43f60ff5cefc1d269>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useDateSelectorAvailabilityDateInfoQuery$variables = {
  courseBucketIds?: ReadonlyArray<string> | null | undefined;
  endDate: string;
  endTime?: string | null | undefined;
  facilityId: string;
  groupSize?: number | null | undefined;
  maxDuration: number;
  minDuration: number;
  startDate: string;
  startTime?: string | null | undefined;
};
export type useDateSelectorAvailabilityDateInfoQuery$data = {
  readonly node: {
    readonly agendas?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly availableTimes: ReadonlyArray<{
            readonly time: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly date: string;
          readonly id: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly club?: {
      readonly " $fragmentSpreads": FragmentRefs<"useGetClubStartOfWeekNumberPatron_club">;
    } | null | undefined;
  } | null | undefined;
};
export type useDateSelectorAvailabilityDateInfoQuery = {
  response: useDateSelectorAvailabilityDateInfoQuery$data;
  variables: useDateSelectorAvailabilityDateInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "courseBucketIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endTime"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupSize"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxDuration"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minDuration"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTime"
},
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "facilityId"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "dateGte",
      "variableName": "startDate"
    },
    {
      "kind": "Variable",
      "name": "dateLte",
      "variableName": "endDate"
    }
  ],
  "concreteType": "AgendaConnection",
  "kind": "LinkedField",
  "name": "agendas",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AgendaEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "courseBucketIds",
                  "variableName": "courseBucketIds"
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 1
                },
                {
                  "kind": "Variable",
                  "name": "maxDuration",
                  "variableName": "maxDuration"
                },
                {
                  "kind": "Variable",
                  "name": "minDuration",
                  "variableName": "minDuration"
                },
                {
                  "kind": "Variable",
                  "name": "playerCount",
                  "variableName": "groupSize"
                },
                {
                  "kind": "Variable",
                  "name": "timeGte",
                  "variableName": "startTime"
                },
                {
                  "kind": "Variable",
                  "name": "timeLte",
                  "variableName": "endTime"
                }
              ],
              "concreteType": "AgendaTime",
              "kind": "LinkedField",
              "name": "availableTimes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "time",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useDateSelectorAvailabilityDateInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Club",
                "kind": "LinkedField",
                "name": "club",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useGetClubStartOfWeekNumberPatron_club"
                  }
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useDateSelectorAvailabilityDateInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Club",
                "kind": "LinkedField",
                "name": "club",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "calendarStartDay",
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "type": "Facility",
            "abstractKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a99e92b1364527e33b273c27c233086b",
    "id": null,
    "metadata": {},
    "name": "useDateSelectorAvailabilityDateInfoQuery",
    "operationKind": "query",
    "text": "query useDateSelectorAvailabilityDateInfoQuery(\n  $facilityId: ID!\n  $startDate: Date!\n  $endDate: Date!\n  $minDuration: Int!\n  $maxDuration: Int!\n  $courseBucketIds: [ID!]\n  $groupSize: Int\n  $startTime: Time\n  $endTime: Time\n) {\n  node(id: $facilityId) {\n    __typename\n    ... on Facility {\n      club {\n        ...useGetClubStartOfWeekNumberPatron_club\n        id\n      }\n      agendas(dateGte: $startDate, dateLte: $endDate) {\n        edges {\n          node {\n            id\n            date\n            availableTimes(courseBucketIds: $courseBucketIds, minDuration: $minDuration, maxDuration: $maxDuration, first: 1, playerCount: $groupSize, timeGte: $startTime, timeLte: $endTime) {\n              time\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment useGetClubStartOfWeekNumberPatron_club on Club {\n  calendarStartDay\n}\n"
  }
};
})();

(node as any).hash = "b6a990c3d7d097cbc377e26a908e4213";

export default node;
